import classnames from 'classnames';
import React from 'react';
import { Link } from 'react-router-dom';

import { Image } from 'src/app/components/Image/Image';
import { OverlayDuration } from 'src/app/components/Overlay/OverlayDuration';
import { Play } from 'src/app/components/Play/Play';
import { PlaylistAddtoMenu } from 'src/app/components/Playlist/PlaylistAddtoMenu';
import { ResponsiveContainer } from 'src/app/components/ResponsiveContainer/ResponsiveContainer';
import { VideoTeaser } from 'src/app/components/Video/VideoTeaser';
import { EventTrack } from 'src/app/helpers/analytics';
import { withStyles } from 'src/app/helpers/styles';
import { Playlist } from 'src/app/models/playlist';

interface MyOwnProps {
  id: string;
  duration: number;
  thumbnail: string;
  title: string;
  videoPath: string;
  className?: string;
  isActive?: boolean;
  isInWatchlist?: boolean;
  isLarge?: boolean;
  onWatchlistButtonClick?: VoidFunction;
  pushAnalytics?: VoidFunction;
  queryParams?: string;
  railAnalytics?: string;
  inPlaylists?: Playlist[];
  showAddToMenu?: boolean;
  userPlaylists?: Playlist[];
  addToPushEvent?: EventTrack;
}

interface MyState {
  isHover: boolean;
}

type MyProps = MyOwnProps;

@withStyles({
  base: [],
  desktop: [require('./VideoThumbnail.desktop.scss')]
})
class MyClassVideoThumbnail extends React.Component<MyProps, MyState> {
  constructor(props: MyProps) {
    super(props);

    this.state = {
      isHover: false
    };

    this.hover = this.hover.bind(this);
  }

  hover(hoverState: boolean): void {
    this.setState({ isHover: hoverState });
  }

  render(): JSX.Element {
    const { className, duration, id, isActive, showAddToMenu, isLarge, pushAnalytics, queryParams, railAnalytics, title, thumbnail, videoPath, onWatchlistButtonClick } = this.props;
    return (
      <div onMouseEnter={() => this.hover(true)} onMouseLeave={() => this.hover(false)} className={classnames('position-relative video-thumbnail', { 'video-thumbnail--active': isActive }, className)}>
        <Link
          className="position-relative d-block video-thumbnail__link"
          to={{ pathname: videoPath, search: queryParams, state: { railAnalytics } }}
          onClick={pushAnalytics}
        >
          <ResponsiveContainer modifier="16-9">
            <Image className="w-100" alt={title} src={thumbnail} />
          </ResponsiveContainer>

          {this.state.isHover && (
            <div className="position-absolute video-thumbnail__video-teaser">
              <ResponsiveContainer modifier="16-9">
                <VideoTeaser videoId={id} />
              </ResponsiveContainer>
            </div>
          )}

          <OverlayDuration duration={duration} className="video-thumbnail__duration" />

          <Play className="d-none video-thumbnail__play" isLarge={isLarge} />
        </Link>

        {showAddToMenu &&
          <PlaylistAddtoMenu
            id={id}
            isInWatchlist={this.props.isInWatchlist ?? false}
            onWatchlistButtonClick={onWatchlistButtonClick}
            inPlaylists={this.props.inPlaylists ?? []}
            userPlaylists={this.props.userPlaylists ?? []}
            className="d-none bg-jetblack position-absolute video-thumbnail__addTo"
            addToPushEventTrack={this.props.addToPushEvent}
          />
        }
      </div>
    );
  }
}

export const VideoThumbnail = MyClassVideoThumbnail as React.ComponentClass<MyOwnProps>;
